// ref https://github.com/stereobooster/react-simple-country-select/blob/master/src/countries.json
export const countryList = [

    { "name": "Afghanistan", "cca2": "AF", "label": "🇦🇫", "value": "93" },

    { "name": "Angola", "cca2": "AO", "label": "🇦🇴", "value": "244" },

    { "name": "Albania", "cca2": "AL", "label": "🇦🇱", "value": "355" },

    { "name": "Andorra", "cca2": "AD", "label": "🇦🇩", "value": "376" },

    { "name": "United Arab Emirates", "cca2": "AE", "label": "🇦🇪", "value": "971" },

    { "name": "Argentina", "cca2": "AR", "label": "🇦🇷", "value": "54" },

    { "name": "Armenia", "cca2": "AM", "label": "🇦🇲", "value": "374" },

    { "name": "Antigua and Barbuda", "cca2": "AG", "label": "🇦🇬", "value": "1268" },

    { "name": "Australia", "cca2": "AU", "label": "🇦🇺", "value": "61" },

    { "name": "Austria", "cca2": "AT", "label": "🇦🇹", "value": "43" },

    { "name": "Azerbaijan", "cca2": "AZ", "label": "🇦🇿", "value": "994" },

    { "name": "Burundi", "cca2": "BI", "label": "🇧🇮", "value": "257" },

    { "name": "Belgium", "cca2": "BE", "label": "🇧🇪", "value": "32" },

    { "name": "Benin", "cca2": "BJ", "label": "🇧🇯", "value": "229" },

    { "name": "Burkina Faso", "cca2": "BF", "label": "🇧🇫", "value": "226" },

    { "name": "Bangladesh", "cca2": "BD", "label": "🇧🇩", "value": "880" },

    { "name": "Bulgaria", "cca2": "BG", "label": "🇧🇬", "value": "359" },

    { "name": "Bahrain", "cca2": "BH", "label": "🇧🇭", "value": "973" },

    { "name": "Bahamas", "cca2": "BS", "label": "🇧🇸", "value": "1242" },

    { "name": "Bosnia and Herzegovina", "cca2": "BA", "label": "🇧🇦", "value": "387" },

    { "name": "Belarus", "cca2": "BY", "label": "🇧🇾", "value": "375" },

    { "name": "Belize", "cca2": "BZ", "label": "🇧🇿", "value": "501" },

    { "name": "Bolivia", "cca2": "BO", "label": "🇧🇴", "value": "591" },

    { "name": "Brazil", "cca2": "BR", "label": "🇧🇷", "value": "55" },

    { "name": "Barbados", "cca2": "BB", "label": "🇧🇧", "value": "1246" },

    { "name": "Brunei", "cca2": "BN", "label": "🇧🇳", "value": "673" },

    { "name": "Bhutan", "cca2": "BT", "label": "🇧🇹", "value": "975" },

    { "name": "Botswana", "cca2": "BW", "label": "🇧🇼", "value": "267" },

    {

        "name": "Central African Republic",

        "cca2": "CF",

        "label": "🇨🇫",

        "value": "236"

    },

    { "name": "Canada", "cca2": "CA", "label": "🇨🇦", "value": "1" },

    { "name": "Switzerland", "cca2": "CH", "label": "🇨🇭", "value": "41" },

    { "name": "Chile", "cca2": "CL", "label": "🇨🇱", "value": "56" },

    { "name": "China", "cca2": "CN", "label": "🇨🇳", "value": "86" },

    { "name": "Ivory Coast", "cca2": "CI", "label": "🇨🇮", "value": "225" },

    { "name": "Cameroon", "cca2": "CM", "label": "🇨🇲", "value": "237" },

    { "name": "DR Congo", "cca2": "CD", "label": "🇨🇩", "value": "243" },

    { "name": "Republic of the Congo", "cca2": "CG", "label": "🇨🇬", "value": "242" },

    { "name": "Colombia", "cca2": "CO", "label": "🇨🇴", "value": "57" },

    { "name": "Comoros", "cca2": "KM", "label": "🇰🇲", "value": "269" },

    { "name": "Cape Verde", "cca2": "CV", "label": "🇨🇻", "value": "238" },

    { "name": "Costa Rica", "cca2": "CR", "label": "🇨🇷", "value": "506" },

    { "name": "Cuba", "cca2": "CU", "label": "🇨🇺", "value": "53" },

    { "name": "Cyprus", "cca2": "CY", "label": "🇨🇾", "value": "357" },

    { "name": "Czechia", "cca2": "CZ", "label": "🇨🇿", "value": "420" },

    { "name": "Germany", "cca2": "DE", "label": "🇩🇪", "value": "49" },

    { "name": "Djibouti", "cca2": "DJ", "label": "🇩🇯", "value": "253" },

    { "name": "Dominica", "cca2": "DM", "label": "🇩🇲", "value": "1767" },

    { "name": "Denmark", "cca2": "DK", "label": "🇩🇰", "value": "45" },

    { "name": "Dominican Republic", "cca2": "DO", "label": "🇩🇴", "value": "1809" },

    { "name": "Algeria", "cca2": "DZ", "label": "🇩🇿", "value": "213" },

    { "name": "Ecuador", "cca2": "EC", "label": "🇪🇨", "value": "593" },

    { "name": "Egypt", "cca2": "EG", "label": "🇪🇬", "value": "20" },

    { "name": "Eritrea", "cca2": "ER", "label": "🇪🇷", "value": "291" },

    { "name": "Spain", "cca2": "ES", "label": "🇪🇸", "value": "34" },

    { "name": "Estonia", "cca2": "EE", "label": "🇪🇪", "value": "372" },

    { "name": "Ethiopia", "cca2": "ET", "label": "🇪🇹", "value": "251" },

    { "name": "Finland", "cca2": "FI", "label": "🇫🇮", "value": "358" },

    { "name": "Fiji", "cca2": "FJ", "label": "🇫🇯", "value": "679" },

    { "name": "France", "cca2": "FR", "label": "🇫🇷", "value": "33" },

    { "name": "Micronesia", "cca2": "FM", "label": "🇫🇲", "value": "691" },

    { "name": "Gabon", "cca2": "GA", "label": "🇬🇦", "value": "241" },

    { "name": "United Kingdom", "cca2": "GB", "label": "🇬🇧", "value": "44" },

    { "name": "Georgia", "cca2": "GE", "label": "🇬🇪", "value": "995" },

    { "name": "Ghana", "cca2": "GH", "label": "🇬🇭", "value": "233" },

    { "name": "Guinea", "cca2": "GN", "label": "🇬🇳", "value": "224" },

    { "name": "Gambia", "cca2": "GM", "label": "🇬🇲", "value": "220" },

    { "name": "Guinea-Bissau", "cca2": "GW", "label": "🇬🇼", "value": "245" },

    { "name": "Equatorial Guinea", "cca2": "GQ", "label": "🇬🇶", "value": "240" },

    { "name": "Greece", "cca2": "GR", "label": "🇬🇷", "value": "30" },

    { "name": "Grenada", "cca2": "GD", "label": "🇬🇩", "value": "1473" },

    { "name": "Guatemala", "cca2": "GT", "label": "🇬🇹", "value": "502" },

    { "name": "Guyana", "cca2": "GY", "label": "🇬🇾", "value": "592" },

    { "name": "Honduras", "cca2": "HN", "label": "🇭🇳", "value": "504" },

    { "name": "Croatia", "cca2": "HR", "label": "🇭🇷", "value": "385" },

    { "name": "Haiti", "cca2": "HT", "label": "🇭🇹", "value": "509" },

    { "name": "Hungary", "cca2": "HU", "label": "🇭🇺", "value": "36" },

    { "name": "Indonesia", "cca2": "ID", "label": "🇮🇩", "value": "62" },

    { "name": "India", "cca2": "IN", "label": "🇮🇳", "value": "91" },

    { "name": "Ireland", "cca2": "IE", "label": "🇮🇪", "value": "353" },

    { "name": "Iran", "cca2": "IR", "label": "🇮🇷", "value": "98" },

    { "name": "Iraq", "cca2": "IQ", "label": "🇮🇶", "value": "964" },

    { "name": "Iceland", "cca2": "IS", "label": "🇮🇸", "value": "354" },

    { "name": "Israel", "cca2": "IL", "label": "🇮🇱", "value": "972" },

    { "name": "Italy", "cca2": "IT", "label": "🇮🇹", "value": "39" },

    { "name": "Jamaica", "cca2": "JM", "label": "🇯🇲", "value": "1876" },

    { "name": "Jordan", "cca2": "JO", "label": "🇯🇴", "value": "962" },

    { "name": "Japan", "cca2": "JP", "label": "🇯🇵", "value": "81" },

    { "name": "Kazakhstan", "cca2": "KZ", "label": "🇰🇿", "value": "76" },

    { "name": "Kenya", "cca2": "KE", "label": "🇰🇪", "value": "254" },

    { "name": "Kyrgyzstan", "cca2": "KG", "label": "🇰🇬", "value": "996" },

    { "name": "Cambodia", "cca2": "KH", "label": "🇰🇭", "value": "855" },

    { "name": "Kiribati", "cca2": "KI", "label": "🇰🇮", "value": "686" },

    { "name": "Saint Kitts and Nevis", "cca2": "KN", "label": "🇰🇳", "value": "1869" },

    { "name": "South Korea", "cca2": "KR", "label": "🇰🇷", "value": "82" },

    { "name": "Kuwait", "cca2": "KW", "label": "🇰🇼", "value": "965" },

    { "name": "Laos", "cca2": "LA", "label": "🇱🇦", "value": "856" },

    { "name": "Lebanon", "cca2": "LB", "label": "🇱🇧", "value": "961" },

    { "name": "Liberia", "cca2": "LR", "label": "🇱🇷", "value": "231" },

    { "name": "Libya", "cca2": "LY", "label": "🇱🇾", "value": "218" },

    { "name": "Saint Lucia", "cca2": "LC", "label": "🇱🇨", "value": "1758" },

    { "name": "Liechtenstein", "cca2": "LI", "label": "🇱🇮", "value": "423" },

    { "name": "Sri Lanka", "cca2": "LK", "label": "🇱🇰", "value": "94" },

    { "name": "Lesotho", "cca2": "LS", "label": "🇱🇸", "value": "266" },

    { "name": "Lithuania", "cca2": "LT", "label": "🇱🇹", "value": "370" },

    { "name": "Luxembourg", "cca2": "LU", "label": "🇱🇺", "value": "352" },

    { "name": "Latvia", "cca2": "LV", "label": "🇱🇻", "value": "371" },

    { "name": "Morocco", "cca2": "MA", "label": "🇲🇦", "value": "212" },

    { "name": "Monaco", "cca2": "MC", "label": "🇲🇨", "value": "377" },

    { "name": "Moldova", "cca2": "MD", "label": "🇲🇩", "value": "373" },

    { "name": "Madagascar", "cca2": "MG", "label": "🇲🇬", "value": "261" },

    { "name": "Maldives", "cca2": "MV", "label": "🇲🇻", "value": "960" },

    { "name": "Mexico", "cca2": "MX", "label": "🇲🇽", "value": "52" },

    { "name": "Marshall Islands", "cca2": "MH", "label": "🇲🇭", "value": "692" },

    { "name": "Macedonia", "cca2": "MK", "label": "🇲🇰", "value": "389" },

    { "name": "Mali", "cca2": "ML", "label": "🇲🇱", "value": "223" },

    { "name": "Malta", "cca2": "MT", "label": "🇲🇹", "value": "356" },

    { "name": "Myanmar", "cca2": "MM", "label": "🇲🇲", "value": "95" },

    { "name": "Montenegro", "cca2": "ME", "label": "🇲🇪", "value": "382" },

    { "name": "Mongolia", "cca2": "MN", "label": "🇲🇳", "value": "976" },

    { "name": "Mozambique", "cca2": "MZ", "label": "🇲🇿", "value": "258" },

    { "name": "Mauritania", "cca2": "MR", "label": "🇲🇷", "value": "222" },

    { "name": "Mauritius", "cca2": "MU", "label": "🇲🇺", "value": "230" },

    { "name": "Malawi", "cca2": "MW", "label": "🇲🇼", "value": "265" },

    { "name": "Malaysia", "cca2": "MY", "label": "🇲🇾", "value": "60" },

    { "name": "Namibia", "cca2": "NA", "label": "🇳🇦", "value": "264" },

    { "name": "Niger", "cca2": "NE", "label": "🇳🇪", "value": "227" },

    { "name": "Nigeria", "cca2": "NG", "label": "🇳🇬", "value": "234" },

    { "name": "Nicaragua", "cca2": "NI", "label": "🇳🇮", "value": "505" },

    { "name": "Netherlands", "cca2": "NL", "label": "🇳🇱", "value": "31" },

    { "name": "Norway", "cca2": "NO", "label": "🇳🇴", "value": "47" },

    { "name": "Nepal", "cca2": "NP", "label": "🇳🇵", "value": "977" },

    { "name": "Nauru", "cca2": "NR", "label": "🇳🇷", "value": "674" },

    { "name": "New Zealand", "cca2": "NZ", "label": "🇳🇿", "value": "64" },

    { "name": "Oman", "cca2": "OM", "label": "🇴🇲", "value": "968" },

    { "name": "Pakistan", "cca2": "PK", "label": "🇵🇰", "value": "92" },

    { "name": "Panama", "cca2": "PA", "label": "🇵🇦", "value": "507" },

    { "name": "Peru", "cca2": "PE", "label": "🇵🇪", "value": "51" },

    { "name": "Philippines", "cca2": "PH", "label": "🇵🇭", "value": "63" },

    { "name": "Palau", "cca2": "PW", "label": "🇵🇼", "value": "680" },

    { "name": "Papua New Guinea", "cca2": "PG", "label": "🇵🇬", "value": "675" },

    { "name": "Poland", "cca2": "PL", "label": "🇵🇱", "value": "48" },

    { "name": "North Korea", "cca2": "KP", "label": "🇰🇵", "value": "850" },

    { "name": "Portugal", "cca2": "PT", "label": "🇵🇹", "value": "351" },

    { "name": "Paraguay", "cca2": "PY", "label": "🇵🇾", "value": "595" },

    { "name": "Qatar", "cca2": "QA", "label": "🇶🇦", "value": "974" },

    { "name": "Romania", "cca2": "RO", "label": "🇷🇴", "value": "40" },

    { "name": "Russia", "cca2": "RU", "label": "🇷🇺", "value": "7" },

    { "name": "Rwanda", "cca2": "RW", "label": "🇷🇼", "value": "250" },

    { "name": "Saudi Arabia", "cca2": "SA", "label": "🇸🇦", "value": "966" },

    { "name": "Sudan", "cca2": "SD", "label": "🇸🇩", "value": "249" },

    { "name": "Senegal", "cca2": "SN", "label": "🇸🇳", "value": "221" },

    { "name": "Singapore", "cca2": "SG", "label": "🇸🇬", "value": "65" },

    { "name": "Solomon Islands", "cca2": "SB", "label": "🇸🇧", "value": "677" },

    { "name": "Sierra Leone", "cca2": "SL", "label": "🇸🇱", "value": "232" },

    { "name": "El Salvador", "cca2": "SV", "label": "🇸🇻", "value": "503" },

    { "name": "San Marino", "cca2": "SM", "label": "🇸🇲", "value": "378" },

    { "name": "Somalia", "cca2": "SO", "label": "🇸🇴", "value": "252" },

    { "name": "Serbia", "cca2": "RS", "label": "🇷🇸", "value": "381" },

    { "name": "South Sudan", "cca2": "SS", "label": "🇸🇸", "value": "211" },

    { "name": "São Tomé and Príncipe", "cca2": "ST", "label": "🇸🇹", "value": "239" },

    { "name": "Suriname", "cca2": "SR", "label": "🇸🇷", "value": "597" },

    { "name": "Slovakia", "cca2": "SK", "label": "🇸🇰", "value": "421" },

    { "name": "Slovenia", "cca2": "SI", "label": "🇸🇮", "value": "386" },

    { "name": "Sweden", "cca2": "SE", "label": "🇸🇪", "value": "46" },

    { "name": "Swaziland", "cca2": "SZ", "label": "🇸🇿", "value": "268" },

    { "name": "Seychelles", "cca2": "SC", "label": "🇸🇨", "value": "248" },

    { "name": "Syria", "cca2": "SY", "label": "🇸🇾", "value": "963" },

    { "name": "Chad", "cca2": "TD", "label": "🇹🇩", "value": "235" },

    { "name": "Togo", "cca2": "TG", "label": "🇹🇬", "value": "228" },

    { "name": "Thailand", "cca2": "TH", "label": "🇹🇭", "value": "66" },

    { "name": "Tajikistan", "cca2": "TJ", "label": "🇹🇯", "value": "992" },

    { "name": "Turkmenistan", "cca2": "TM", "label": "🇹🇲", "value": "993" },

    { "name": "Timor-Leste", "cca2": "TL", "label": "🇹🇱", "value": "670" },

    { "name": "Tonga", "cca2": "TO", "label": "🇹🇴", "value": "676" },

    { "name": "Trinidad and Tobago", "cca2": "TT", "label": "🇹🇹", "value": "1868" },

    { "name": "Tunisia", "cca2": "TN", "label": "🇹🇳", "value": "216" },

    { "name": "Turkey", "cca2": "TR", "label": "🇹🇷", "value": "90" },

    { "name": "Tuvalu", "cca2": "TV", "label": "🇹🇻", "value": "688" },

    { "name": "Tanzania", "cca2": "TZ", "label": "🇹🇿", "value": "255" },

    { "name": "Uganda", "cca2": "UG", "label": "🇺🇬", "value": "256" },

    { "name": "Ukraine", "cca2": "UA", "label": "🇺🇦", "value": "380" },

    { "name": "Uruguay", "cca2": "UY", "label": "🇺🇾", "value": "598" },

    { "name": "United States", "cca2": "US", "label": "🇺🇸", "value": "1" },

    { "name": "Uzbekistan", "cca2": "UZ", "label": "🇺🇿", "value": "998" },

    { "name": "Vatican City", "cca2": "VA", "label": "🇻🇦", "value": "3906698" },

    {

        "name": "Saint Vincent and the Grenadines",

        "cca2": "VC",

        "label": "🇻🇨",

        "value": "1784"

    },

    { "name": "Venezuela", "cca2": "VE", "label": "🇻🇪", "value": "58" },

    { "name": "Vietnam", "cca2": "VN", "label": "🇻🇳", "value": "84" },

    { "name": "Vanuatu", "cca2": "VU", "label": "🇻🇺", "value": "678" },

    { "name": "Samoa", "cca2": "WS", "label": "🇼🇸", "value": "685" },

    { "name": "Yemen", "cca2": "YE", "label": "🇾🇪", "value": "967" },

    { "name": "South Africa", "cca2": "ZA", "label": "🇿🇦", "value": "27" },

    { "name": "Zambia", "cca2": "ZM", "label": "🇿🇲", "value": "260" },

    { "name": "Zimbabwe", "cca2": "ZW", "label": "🇿🇼", "value": "263" }

]